import { PhoneCall } from "lucide-react";
import type { WidgetDef } from "../types";
import { CallNowGlance, CallNowView } from "./CallNowWidget";
import { CallNowSettings } from "./CallNowSettings";
import { defaultCallNowConfig, parseCallNowConfig, type CallNowConfig } from "./config";

export const callNowWidget: WidgetDef<CallNowConfig> = {
  type: "callnow",
  icon: PhoneCall,
  title: "callnow.title",
  description: "callnow.description",
  sizes: ["s", "m", "l"],
  defaultSize: "m",
  defaultConfig: defaultCallNowConfig,
  parseConfig: parseCallNowConfig,
  available: (me) => me.role !== "carrier",
  View: CallNowView,
  Glance: CallNowGlance,
  Settings: CallNowSettings,
};
